var _style, _path, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#D80027;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2H256z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.5,33.4c-40,22.8-73.3,56.1-96.1,96.1V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,224.5l-91-91h-31.5v0L256,256h0C256,256,256,234.3,256,224.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,256l4.7,14.6h15.3l-12.4,9l4.7,14.6l-12.4-9l-12.4,9l4.7-14.6l-12.4-9h15.3L345,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.1,282.1l13.7,7l10.8-10.8l-2.4,15.1l13.7,7l-15.1,2.4l-2.4,15.1l-7-13.7l-15.1,2.4l10.8-10.8L282.1,282.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,345l14.6-4.7l0-15.3l9,12.4l14.6-4.7l-9,12.4l9,12.4l-14.6-4.7l-9,12.4v-15.3L256,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.1,408l7-13.7l-10.8-10.8l15.1,2.4l7-13.7l2.4,15.1l15.1,2.4l-13.7,7l2.4,15.1L295.7,401L282.1,408z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,434.1l-4.7-14.6H325l12.4-9l-4.7-14.6l12.4,9l12.4-9l-4.7,14.6l12.4,9h-15.3L345,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,408l-13.7-7l-10.8,10.8l2.4-15.1l-13.7-7l15.1-2.4l2.4-15.1l7,13.7l15.1-2.4L401,394.4L408,408z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.1,345l-14.6,4.7v15.3l-9-12.4l-14.6,4.7l9-12.4l-9-12.4l14.6,4.7l9-12.4v15.3L434.1,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408,282.1l-7,13.7l10.8,10.8l-15.1-2.4l-7,13.7l-2.4-15.1l-15.1-2.4l13.7-7l-2.4-15.1l10.8,10.8L408,282.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.35538a75e6752e6fb97d1da6fa182046.svg";
export { ForwardRef as ReactComponent };